// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const DeleteGoalDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-deletegoaldialogcontainer" */ "./DeleteGoalDialogContainer")).then((bundle)=>{
        return {
            default: bundle.DeleteGoalDialogContainer
        };
    });
export const LazyDeleteGoalDialogContainer = /*#__PURE__*/ lazy(DeleteGoalDialogContainerLazyLoader);
